import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminInvoices_invoiceIdDownload = z.any()
export type TagsGetAdminInvoices_invoiceIdDownload = z.infer<typeof tagsGetAdminInvoices_invoiceIdDownload>

export const descriptionGetAdminInvoices_invoiceIdDownload = z.any()
export type DescriptionGetAdminInvoices_invoiceIdDownload = z.infer<typeof descriptionGetAdminInvoices_invoiceIdDownload>

export const paramsGetAdminInvoices_invoiceIdDownload = z.object({ "invoiceId": z.string().uuid() })
export type ParamsGetAdminInvoices_invoiceIdDownload = z.infer<typeof paramsGetAdminInvoices_invoiceIdDownload>

export const querystringGetAdminInvoices_invoiceIdDownload = z.object({ "fileName": z.string().optional() })
export type QuerystringGetAdminInvoices_invoiceIdDownload = z.infer<typeof querystringGetAdminInvoices_invoiceIdDownload>

export const responseGetAdminInvoices_invoiceIdDownload = z.any()
export type ResponseGetAdminInvoices_invoiceIdDownload = z.infer<typeof responseGetAdminInvoices_invoiceIdDownload>

interface IGetAdminInvoices_invoiceIdDownload extends BaseMethodType {
  tags: TagsGetAdminInvoices_invoiceIdDownload,
  description: DescriptionGetAdminInvoices_invoiceIdDownload,
  params: ParamsGetAdminInvoices_invoiceIdDownload,
  querystring: QuerystringGetAdminInvoices_invoiceIdDownload,
  response: ResponseGetAdminInvoices_invoiceIdDownload
}
export const URL = '/admin/invoices/:invoiceId/download'
export const validation = {
  get: {
    tags: tagsGetAdminInvoices_invoiceIdDownload,
    description: descriptionGetAdminInvoices_invoiceIdDownload,
    params: paramsGetAdminInvoices_invoiceIdDownload,
    querystring: querystringGetAdminInvoices_invoiceIdDownload,
    response: responseGetAdminInvoices_invoiceIdDownload
  }
}
export interface AdminInvoices_invoiceIdDownload extends BaseRouteType {
  get: IGetAdminInvoices_invoiceIdDownload
}